import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CategoryTabs from './CategoryTabs';
import './NavigationGrid.css';

const NavigationGrid = ({ dashboards, categories }) => {
  const [activeCategory, setActiveCategory] = useState(null);
  const navigate = useNavigate();

  const handleCardClick = (dashboardId) => {
    navigate(`/dashboard/${dashboardId}`);
  };

  // 根据选中的分类筛选dashboard
  const filteredDashboards = activeCategory 
    ? dashboards.filter(dashboard => dashboard.category === activeCategory)
    : dashboards;

  // 计算分类统计
  const categoryStats = categories.map(category => ({
    ...category,
    count: dashboards.filter(d => d.category === category.id).length
  }));

  return (
    <div className="navigation-container">
      <h1 className="page-title">📊 Faray数据中心</h1>
      
      <CategoryTabs 
        categories={categoryStats}
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />

      <div className="category-info">
        {activeCategory && (
          <div className="active-category-info">
            {categories.find(c => c.id === activeCategory)?.description} 
            <span className="dashboard-count">
              (共 {filteredDashboards.length} 个仪表板)
            </span>
          </div>
        )}
        {!activeCategory && (
          <div className="active-category-info">
            显示全部仪表板 
            <span className="dashboard-count">
              (共 {dashboards.length} 个)
            </span>
          </div>
        )}
      </div>
      
      <div className="navigation-grid">
        {filteredDashboards.map((dashboard) => (
          <div
            key={dashboard.id}
            className="nav-card"
            onClick={() => handleCardClick(dashboard.id)}
          >
            <div className="nav-card-icon">{dashboard.icon}</div>
            <div className="nav-card-title">{dashboard.title}</div>
            <div className="nav-card-description">{dashboard.description}</div>
            <div className="nav-card-category">
              {categories.find(c => c.id === dashboard.category)?.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NavigationGrid; 
